const pre = '/house/';

export default {
    path: '/house',
    title: '房产信息管理',
    header: 'home',
    custom: 'i-icon-demo i-icon-demo-dashboard',
    children: [
        {
            path: `${pre}house`,
            title: '房产信息管理'
        }
    ]
}
